// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;
Vue.use(ElementUI);

// 全局组件
import Header from './components/header';
import Footer  from './components/footer';
import inputTel  from './components/inputTel';
import More  from './components/More';
import Case  from './components/case';
import Banner  from './components/banner';
import ImageText  from './components/ImageText';
import Swiper  from './components/swiper';
import inputT  from './components/inputT';
import Loding  from './components/loding';
import axios from 'axios'
import VueWechatTitle from 'vue-wechat-title' //可以动态修改浏览器标题的插件

Vue.component('Header',Header);
Vue.component('Footer',Footer);
Vue.component('InputTel',inputTel);
Vue.component('More',More);
Vue.component('Case',Case);
Vue.component('Banner',Banner);
Vue.component('ImageText',ImageText);
Vue.component('Swiper',Swiper);
Vue.component('inputT',inputT);
Vue.component('Loding',Loding);
Vue.component('axios',axios);
Vue.use(VueWechatTitle);

Vue.mixin({
	methods: {
		toPath(url,query) {
            console.log(url)
            window.open(url);
            // this.$router.replace({path:url,query:query});
        },
	}
})
// 创建 axios 实例
const service = axios.create({
    baseURL: './api', // api base_url
    timeout: 9000 // 请求超时时间
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
export function uploadAction(url,parameter){
    return axios({
        url: url,
        data: parameter,
        method:'GET' ,
        headers: {
            'Content-Type': 'multipart/form-data',  // 文件上传
        },
    })
}
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    components: { App },
    template: '<App/>',
    data: {
        keywords: "",
        description: "",
        title: "",
        viewId: 1
    },
    created() {

    },
    methods: {
    },
})

export {
    service as axios
}



// WEBPACK FOOTER //
// ./src/main.js